module.exports = __webpack_public_path__ + "img/Yr5FundsUsage.d22a2f1a.png";